import { render } from "./UsuarioResumenEstadisticas.vue?vue&type=template&id=2546ad32"
import script from "./UsuarioResumenEstadisticas.vue?vue&type=script&lang=js"
export * from "./UsuarioResumenEstadisticas.vue?vue&type=script&lang=js"

import "./UsuarioResumenEstadisticas.vue?vue&type=style&index=0&id=2546ad32&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__